// extracted by mini-css-extract-plugin
module.exports = {"planDetailContainer":"PlanDetails_planDetailContainer__1yTpo"};